import { Form } from 'modules/forms';
import { usePathBase } from 'modules/routes';
import PropTypes from 'prop-types';

/**
 * Edits replacement text, forwarding nested-form callbacks and the current route.
 * @param {Object} props - Form data, nested index, and save/cancel callbacks.
 * @returns {React.ReactElement} Replacement text form.
 */
export default function SingleTextInputForm({
    index,
    submitData,
    onSubmitCallback,
    onCancel,
    formClasses,
    data,
    nested,
}) {
    const pathBase = usePathBase();

    return (
        <Form
            scope="text"
            onSubmit={(params) => {
                // TODO: Check if it is correct to pass index here. If submitData is the Redux action
                // dispatcher, index has no effect there. But if submitData is a custom function,
                // it might need index (e.g. nested forms).
                submitData({ pathBase }, params, index);
            }}
            onSubmitCallback={onSubmitCallback}
            onCancel={onCancel}
            data={data}
            nested={nested}
            formClasses={formClasses}
            elements={[
                { attribute: 'text_to_mark' },
                { attribute: 'replacement' },
            ]}
        />
    );
}

SingleTextInputForm.propTypes = {
    index: PropTypes.number,
    submitData: PropTypes.func.isRequired,
    onSubmitCallback: PropTypes.func,
    onCancel: PropTypes.func,
    formClasses: PropTypes.string,
    data: PropTypes.object,
    nested: PropTypes.bool,
};
